import {useState} from "react";
import {Input} from "../../input";
import {Button} from "../../button";

type NumberFilterProps = {
    value: number | null;
    onChange: (value: string) => void | Promise<void>;
    onApply: (value: number | null) => void | Promise<void>;
    onClear: (value: number | null) => void | Promise<void>;
    placeholder?: string | null;
    title?: string | null;
};

const NumberFilter = ({
                          value,
                          onChange,
                          onApply,
                          onClear,
                          placeholder,
                          title
                      }: NumberFilterProps) => {
    const [inputValue, setInputValue] = useState<string>(value?.toString() || "");

    const handleApply = () => {
        const val = inputValue === "" ? null : Number(inputValue);
        onApply(val);
    };

    const handleClear = () => {
        onClear(null);
        setInputValue("");
    };

    return (
        <div className="p-2" onKeyDown={e => e.stopPropagation()}>
            <span className="block my-2 mx-1 text-xs uppercase text-[#6A7282]">
                {title || null}
            </span>
            <Input
                type="number"
                className="w-full h-10 mb-2 no-spinner"
                value={inputValue ?? ''}
                onChange={e => setInputValue(e.target.value)}
                placeholder={placeholder || "Search..."}
            />
            <div className="flex w-full mt-2">
                <Button
                    className="w-[60%] mr-1 text-xs"
                    onClick={handleApply}
                >
                    Apply
                </Button>
                <Button
                    variant="outline"
                    className="w-[40%] text-xs"
                    onClick={handleClear}
                >
                    Clear
                </Button>
            </div>
        </div>
    );
};

export default NumberFilter;
